import { Link } from 'react-router-dom';
import { Shield, Mail, MessageCircle, Instagram, Youtube, Twitter, Facebook, Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-slate-950 border-t border-slate-800" data-testid="footer">
      {/* Large background text */}
      <div className="absolute inset-0 flex items-center justify-center overflow-hidden pointer-events-none">
        <span 
          className="text-[12rem] md:text-[20rem] font-extrabold text-slate-900/30 select-none whitespace-nowrap"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Sozialsetu
        </span>
      </div>

      <div className="relative container-custom py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand Section */}
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_social-safeguard-3/artifacts/w47k1zj3_Gemini_Generated_Image_r3la8tr3la8tr3la.png" 
                alt="Sozialsetu Logo" 
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-slate-400 text-base leading-relaxed mb-6 max-w-md">
              Proactive social media monitoring and cyber insurance for India's digital creators. 
              Protect your reputation, content, and income.
            </p>
            
            {/* Contact CTAs */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="mailto:contactus@sozialsetu.com"
                className="flex items-center gap-2 text-slate-300 hover:text-cyan-400 transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5" />
                <span>contactus@sozialsetu.com</span>
              </a>
              <a
                href="https://wa.me/919986573456"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-green-600 hover:bg-green-500 text-white px-4 py-2 rounded-full transition-colors"
                data-testid="footer-whatsapp"
              >
                <MessageCircle className="w-5 h-5" />
                <span>WhatsApp Us</span>
              </a>
            </div>
          </div>

          {/* Links Sections */}
          <div className="md:col-span-3">
            <h4 className="text-white font-bold mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Product
            </h4>
            <ul className="space-y-4">
              <li>
                <Link to="/how-it-works" className="text-slate-400 hover:text-cyan-400 transition-colors" data-testid="footer-link-how-it-works">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-slate-400 hover:text-cyan-400 transition-colors" data-testid="footer-link-pricing">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/why-sozialsetu" className="text-slate-400 hover:text-cyan-400 transition-colors" data-testid="footer-link-why-sozialsetu">
                  Why Sozialsetu
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-white font-bold mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Support
            </h4>
            <ul className="space-y-4">
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-cyan-400 transition-colors" data-testid="footer-link-contact-us">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-cyan-400 transition-colors" data-testid="footer-link-faqs">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div className="md:col-span-2">
            <h4 className="text-white font-bold mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              We Protect
            </h4>
            <div className="flex gap-3 flex-wrap">
              <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:text-pink-400 hover:bg-slate-700 transition-colors cursor-pointer" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </div>
              <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:text-red-500 hover:bg-slate-700 transition-colors cursor-pointer" data-testid="social-youtube">
                <Youtube className="w-5 h-5" />
              </div>
              <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:text-sky-400 hover:bg-slate-700 transition-colors cursor-pointer" data-testid="social-twitter">
                <Twitter className="w-5 h-5" />
              </div>
              <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:text-blue-500 hover:bg-slate-700 transition-colors cursor-pointer" data-testid="social-facebook">
                <Facebook className="w-5 h-5" />
              </div>
              <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:text-blue-400 hover:bg-slate-700 transition-colors cursor-pointer" data-testid="social-linkedin">
                <Linkedin className="w-5 h-5" />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm text-center md:text-left">
              © {currentYear} Sozialsetu. All rights reserved.
            </p>
            <p className="text-slate-600 text-xs text-center md:text-right max-w-2xl">
              Disclaimer: Insurance coverage is subject to policy terms and conditions. 
              Sozialsetu acts as a facilitator for group professional liability insurance products.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
